// /Page/Editor — settings that belong to the page but are not part of it.
//
// One field today: the parameters the preview composes with. A route is matched
// literally — there is no `/post/:slug` segment matching — so nothing supplies
// `{{params.slug}}` on a served page either, and a template written against
// parameters it can never see while editing is one nobody can check. These are
// that source: the author says "preview this page as if slug were about-us",
// and the composer puts them where segment matching eventually will.
//
// Stored on the page rather than in the browser because they belong to the
// content: the parameters that make a template legible are a property of the
// template, and the next person to open it needs the same ones.
export default [
  {
    id: "/Page/Editor/Param",
    type: "object",
    properties: {
      name: { label: "Name", type: "string", default: "" },
      value: { label: "Value", type: "string", default: "" },
    },
    required: [],
  },
  {
    id: "/Page/Editor",
    type: "object",
    properties: {
      params: {
        label: "Preview parameters",
        type: "array",
        items: { $ref: "/Page/Editor/Param" },
        default: [],
      },
    },
    required: [],
  },
];
